import { render } from "./Spell.vue?vue&type=template&id=77b6a0db&scoped=true"
import script from "./Spell.vue?vue&type=script&lang=js"
export * from "./Spell.vue?vue&type=script&lang=js"

import "./Spell.vue?vue&type=style&index=0&id=77b6a0db&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b6a0db"]])

export default __exports__